import getUserOptions from './getUserOptions';

export default (): string | undefined => getUserOptions()?.TimeZone;
